import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';

import packageJson from '../../package.json';
import { VersionService } from './core/version.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgIf],
  templateUrl: './app.html',
  styleUrl: './app.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class App implements OnInit, AfterViewInit {
  titulo = 'Acesso';
  visibilidade = 'hidden';

  renderizacaoOk = false;
  mostrarPagina = false;

  version = packageJson.version;

  constructor(
    private readonly title: Title,
    private readonly cdr: ChangeDetectorRef,
    private versionService: VersionService
  ) {
    this.title.setTitle('Acesso');
  }

  ngOnInit(): void {
    this.versionService.getVersion().subscribe(versionInfo => {
      this.version = versionInfo.version;
    });

    setTimeout(() => {
      this.renderizacaoOk = true;
      this.cdr.markForCheck();
    }, 0);
  }

  ngAfterViewInit(): void {
    this.init();
  }

  init(): void {
    if (!this.renderizacaoOk) {
      setTimeout(() => {
        this.init();
      }, 0);

      return;
    }

    const appBridge = (window as Window & { AppBrk?: () => void }).AppBrk;

    if (typeof appBridge === 'function') {
      appBridge();
    }

    setTimeout(() => {
      this.mostrarPagina = true;
      this.visibilidade = 'visible';
      this.cdr.markForCheck();
    }, 800);
  }
}